import React from "react";

interface ChartStateProps {
  loading: boolean;
  error: string | null;
  empty: boolean;
  onRetry?: () => void;
  children: React.ReactNode;
}

export const ChartState: React.FC<ChartStateProps> = ({
  loading,
  error,
  empty,
  onRetry,
  children,
}) => {
  if (loading) {
    return (
      <div className="chart-state chart-state--loading">
        <div className="loading-spinner">Загрузка...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="chart-state chart-state--error">
        <div>Ошибка: {error}</div>
        {onRetry ? (
          <button
            type="button"
            className="simple-button"
            onClick={onRetry}
          >
            Повторить
          </button>
        ) : null}
      </div>
    );
  }

  if (empty) {
    return (
      <div className="chart-state chart-state--empty">
        Нет данных за выбранный период
      </div>
    );
  }

  return <>{children}</>;
};

export default ChartState;
